import { render } from "./BracketMobile.vue?vue&type=template&id=3a6b2c8a&scoped=true"
import script from "./BracketMobile.vue?vue&type=script&lang=js"
export * from "./BracketMobile.vue?vue&type=script&lang=js"

import "./BracketMobile.vue?vue&type=style&index=0&id=3a6b2c8a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6b2c8a"]])

export default __exports__